<template>
  <div class="history-trace-search">
    <div class="nx-card-header search-card-head">
      <div class="nx-card-title">历史轨迹追溯与分析</div>
    </div>
    <div class="filter-section">
      <el-select v-model="value.userId" placeholder="全部人员" size="small" clearable filterable>
        <el-option v-for="item in userList" :key="item.id" :label="formatUserName(item)" :value="item.id"></el-option>
      </el-select>
      <el-date-picker v-model="value.startTime" type="datetime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" size="small"></el-date-picker>
      <el-date-picker v-model="value.endTime" type="datetime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" size="small"></el-date-picker>
      <!-- <el-select v-model="selectedRoute" placeholder="全部线路" clearable>
        <el-option label="全部线路" value="all"></el-option>
        <el-option label="巡检线路A" value="routeA"></el-option>
        <el-option label="巡检线路B" value="routeB"></el-option>
      </el-select> -->
      <el-button type="primary" size="small" @click="handleQuery">查询</el-button>
      <el-button type="default" size="small" @click="handleReset">重置</el-button>
    </div>
  </div>
</template>

<script>
import { getUserList } from '../api'

export default {
  name: 'TraceFilter',
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data () {
    return {
      selectedRoute: 'all',
      userList: [],
    };
  },
  mounted () {
    this.loadUserList()
  },
  methods: {
    loadUserList () {
      getUserList().then(({ data }) => {
        this.userList = Array.isArray(data) ? data : (data && data.data) || []
      })
    },
    formatUserName (item) {
      if (!item) return ''
      return item.name || item.realName || item.real_name || item.nickName || item.nick_name || ''
    },
    handleQuery () {
      this.$emit('handleQuery');
    },
    handleReset () {
      this.$set(this.value, 'workOrderCode', '')
      this.$set(this.value, 'extPlanName', '')
      this.$set(this.value, 'inspectionRouteName', '')
      this.$set(this.value, 'rtkId', '')
      this.$set(this.value, 'userId', '')
      this.$set(this.value, 'startTime', '')
      this.$set(this.value, 'endTime', '')
      this.$emit('handleQuery')
    },
  }
};
</script>

<style lang="scss" scoped>
/* 与 personnel-trajectory-analysis 主页面一致的内联 token（不依赖 @/styles/nx-tokens.scss） */
$nx-color-bg: #f5f7fa;
$nx-color-card: #fff;
$nx-color-text-1: #1f2937;
$nx-color-text-2: #6b7280;
$nx-color-text-3: #909399;
$nx-color-primary: #2563eb;
$nx-color-border: #e5e7eb;
$nx-color-border-2: #ebeef5;
/* 与 Element el-card 圆角 4px 一致 */
$nx-radius-sm: 4px;
$nx-radius-md: 4px;
$nx-radius-lg: 4px;
$nx-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);
$nx-space-1: 4px;
$nx-space-2: 8px;
$nx-space-3: 12px;
$nx-space-4: 16px;
$nx-space-5: 20px;
$nx-space-6: 24px;

@mixin nx-surface-card {
  background: $nx-color-card;
  border: 1px solid $nx-color-border-2;
  border-radius: $nx-radius-lg;
  box-shadow: $nx-shadow-sm;
  box-sizing: border-box;
}

.history-trace-search {
  @include nx-surface-card;
  /* 与全局 .avue-crud__search 下边距一致，与下方主区相隔 12px */
  margin-bottom: 12px;
  flex-shrink: 0;
  overflow: hidden;
}

.search-card-head {
  /* 与 @/basic-common/styles/avue-ui.scss .avue-crud__search 上内边距一致 */
  padding: 16px 12px 12px;
  margin-bottom: 0;
  border-bottom: 1px solid $nx-color-border-2;
}

.search-card-head .nx-card-title {
  font-size: 18px;
  line-height: 1.35;
}

.filter-section {
  display: flex;
  flex-wrap: wrap;
  gap: $nx-space-3 $nx-space-4;
  padding: 12px 12px 16px;
  align-items: center;
}

.filter-section .el-input,
.filter-section .el-date-picker {
  width: 200px;
}

.filter-section ::v-deep .el-date-editor--datetimerange {
  width: 360px;
}
</style>
